import { z } from 'zod';
import { startOfDay, isValid, isBefore } from 'date-fns';
import { DataDeletionRequestLevel } from './types';

export const selectionStepSchema = z
  .object({
    deletionType: z.enum(DataDeletionRequestLevel),
    deletionDate: z
      .date({ message: 'Select a date.' })
      .refine((date) => isValid(date), { message: 'Enter a valid date.' })
      .refine((date) => !isBefore(date, startOfDay(new Date())), {
        message: 'Select a present or future date.',
      }),
    selectedPatients: z.array(z.string()),
    selectedProfiles: z.array(z.string()),
  })
  .refine(
    (data) =>
      data.deletionType !== DataDeletionRequestLevel.SPECIFIC_PATIENTS ||
      data.selectedPatients.length > 0,
    {
      message: 'Select at least one patient.',
      path: ['selectedPatients'],
    },
  )
  .refine(
    (data) =>
      data.deletionType !== DataDeletionRequestLevel.SPECIFIC_PROFILES ||
      data.selectedProfiles.length > 0,
    {
      message: 'Select at least one profile.',
      path: ['selectedProfiles'],
    },
  );

export type SelectionStepFormType = z.infer<typeof selectionStepSchema>;

export const confirmationStepSchema = z.object({
  confirmText: z.string().refine((val) => val === 'Delete', {
    message: 'Text does not match confirmation text.',
  }),
  isExportData: z.boolean(),
});

export type ConfirmationStepFormType = z.infer<typeof confirmationStepSchema>;
